module.exports = require("./ar-AE");